/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainEntitiesAwGameDataViewModel interface.
 */
export function instanceOfFxIdDomainEntitiesAwGameDataViewModel(value) {
    if (!('PlayerName' in value) || value['PlayerName'] === undefined)
        return false;
    if (!('LastLogin' in value) || value['LastLogin'] === undefined)
        return false;
    if (!('TanksCount' in value) || value['TanksCount'] === undefined)
        return false;
    if (!('SocialAccounts' in value) || value['SocialAccounts'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesAwGameDataViewModelFromJSON(json) {
    return FxIdDomainEntitiesAwGameDataViewModelFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesAwGameDataViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PlayerName': json['PlayerName'],
        'LastLogin': (new Date(json['LastLogin'])),
        'TanksCount': json['TanksCount'],
        'SocialAccounts': json['SocialAccounts'],
    };
}
export function FxIdDomainEntitiesAwGameDataViewModelToJSON(json) {
    return FxIdDomainEntitiesAwGameDataViewModelToJSONTyped(json, false);
}
export function FxIdDomainEntitiesAwGameDataViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PlayerName': value['PlayerName'],
        'LastLogin': ((value['LastLogin']).toISOString()),
        'TanksCount': value['TanksCount'],
        'SocialAccounts': value['SocialAccounts'],
    };
}
//# sourceMappingURL=FxIdDomainEntitiesAwGameDataViewModel.js.map